import type { ValidationChecksType } from './reducer';

export const isValidEmail: ValidationChecksType = (field) => {
    const validEmailRegex =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (!field.inputProps.value?.toString().match(validEmailRegex)) {
        field.inputProps.errorMessage = 'Bitte geben Sie einen gültige e-Mail Adressen Format an.';
        return false;
    }
    return true;
};

export const isRequired: ValidationChecksType = (field) => {
    if (field.inputProps.required && field.inputProps.value?.toString().length === 0) {
        field.inputProps.errorMessage = 'Dies ist ein Pflichtfeld.';
        return false;
    }
    return true;
};

export const isCheckboxCLicked: ValidationChecksType = (field) => {
    if (field.inputProps.required && field.inputProps.checked === false) {
        field.inputProps.errorMessage = 'Dies ist ein Pflichtfeld.';
        return false;
    }
    return true;
};

export const isValidZipGermany: ValidationChecksType = (field) => {
    const zipCodeLength = 5;
    const isValidZipCode = /^\d+$/;

    if (!field.inputProps.value?.toString().match(isValidZipCode)) {
        field.inputProps.errorMessage = 'Bitte geben Sie einen gültige deutsche Postleitzahl an.';

        return false;
    }

    if (field.inputProps.value?.toString().length !== zipCodeLength) {
        field.inputProps.errorMessage = 'Postleitzahl entspricht keiner gültigen Länge für Deutschland.';

        return false;
    }

    return true;
};

export const isValidZip: ValidationChecksType = (field) => {
    const isValidZipCode = /^[A-Za-z0-9 -]{2,10}$/;

    if (!field.inputProps.value?.toString().match(isValidZipCode)) {
        field.inputProps.errorMessage = 'Bitte geben Sie einen gültige Postleitzahl an.';

        return false;
    }

    return true;
};

export const isValidUstid: ValidationChecksType = (field) => {
    const isUstidValid = /^[A-Za-z]{2}\d{1,12}$/;

    if (!field.inputProps.value?.toString()) {
        return true;
    }

    if (!field.inputProps.value?.toString().match(isUstidValid)) {
        field.inputProps.errorMessage =
            'Die USt-Identnr. muss mit zwei Buchstaben beginnen, gefolgt von bis zu 12 Zahlen ohne Leerstelle dazwischen.';

        return false;
    }

    return true;
};

export const isValidPhone: ValidationChecksType = (field) => {
    const isPhoneValid = /^(\+)[1-9][0-9 \-]{3,40}$/;
    if (!field.inputProps.value?.toString().match(isPhoneValid)) {
        field.inputProps.errorMessage = 'Bitte geben Sie eine gültige Telefonnummer an.';
        return false;
    }
    return true;
};
